(function () {
  try {
    const checkoutForm = document.getElementById('checkout-delivery') as HTMLFormElement;
    const checkoutFormButton = document.getElementById('to-payment-btn') as HTMLButtonElement;
    console.debug('FED log: checkoutFormEl', checkoutForm);
    console.debug('FED log: checkoutFormButton', checkoutFormButton);
    if (checkoutFormButton && checkoutForm) {
      checkoutFormButton.addEventListener('click', function () {
        console.debug('FED log: checkoutFormButton clicked, setting the button to disabled');
        checkoutFormButton.disabled = true;
        checkoutForm.submit();
        // Enough time to stop double click
        setTimeout(() => {
          console.debug('FED log: Waited 2000ms setting removing disabled state  from checkoutFormButton');
          checkoutFormButton.disabled = false;
        }, 2000);
      });
    }
  } catch (e) {
    console.log(e);
  }
})();
